import { setCookie } from 'cookies-next/client';

const cookieRedirectAfterAuthName = 'redirectAfterAuth';

// eslint-disable-next-line import/prefer-default-export
export function setCookieRedirectAfterAuth(path: string) {
  setCookie(cookieRedirectAfterAuthName, path, { path: '/' });
}
